import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1517832b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list_title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold margin_left" }, "의견", -1))
const _hoisted_3 = { class: "board_top" }
const _hoisted_4 = { class: "black" }
const _hoisted_5 = { class: "gray" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray" }, "·", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray" }, "평균", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "leaf",
  src: "/assets/icon/small_leaf.png"
}, null, -1))
const _hoisted_9 = { class: "gray" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divide" }, " | ", -1))
const _hoisted_11 = { class: "gray" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "board_info space-between" }
const _hoisted_14 = { class: "board_left" }
const _hoisted_15 = { class: "green score" }
const _hoisted_16 = { class: "gray" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  src: "/assets/icon/like_btn.png",
  srcset: "/assets/icon/like_btn@2x.png 2x,/assets/icon/like_btn@3x.png 3x"
}
const _hoisted_19 = {
  key: 1,
  src: "/assets/icon/like_btn_e.png",
  srcset: "/assets/icon/like_btn_e@2x.png 2x,/assets/icon/like_btn_e@3x.png 3x"
}
const _hoisted_20 = { class: "board_content" }
const _hoisted_21 = ["onClick", "innerHTML"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "더보기", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "btn_down_b",
  src: "/assets/icon/btn_down_b.png",
  srcset: "/assets/icon/btn_down_b@2x.png 2x,/assets/icon/btn_down_b@3x.png 3x"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_star_rating_inline = _resolveComponent("star-rating-inline")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_print_og_data = _resolveComponent("print-og-data")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.stockItemBoardsCount), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemBoards, (board) => {
      return (_openBlock(), _createElementBlock("div", {
        key: board.stockItemBoardId,
        class: "board_list"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(board.email), 1),
          _createElementVNode("span", _hoisted_5, "의견 " + _toDisplayString(board.count), 1),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.toFixed(+board.avgPoint, 1)), 1),
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(board.joinCount) + "개 조합 참여", 1),
          (board.isMine)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "more-vertical-btn",
                onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'의견목록', 'clickContent':'MY의견 수정'}); _ctx.openPopover(board, $event)}
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3], (v) => {
                  return _createElementVNode("div", {
                    key: v,
                    class: "gray_circle"
                  })
                }), 64))
              ], 8, _hoisted_12))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_star_rating_inline, {
              class: "inline",
              value: board.point
            }, null, 8, ["value"]),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.toFixed(board.point,1)), 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.prettyDateToOnemonth(board.updateAt)), 1)
          ]),
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent board_right",
            onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'의견목록', 'clickContent':'좋아요 버튼'}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.boardLike(board))}
          }, [
            (board.likeFlag === true)
              ? (_openBlock(), _createElementBlock("img", _hoisted_18))
              : (_openBlock(), _createElementBlock("img", _hoisted_19)),
            _createElementVNode("span", {
              class: _normalizeClass({'deep-blue': board.likeFlag, 'grey': !board.likeFlag})
            }, _toDisplayString(board.likeCount), 3),
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ], 8, _hoisted_17)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("p", {
            class: _normalizeClass({gray:(board.status!='show')}),
            onClick: ($event: any) => (_ctx.boardClick(board,$event)),
            innerHTML: _ctx.printContent(board.contents, true)
          }, null, 10, _hoisted_21),
          (board.ogData)
            ? (_openBlock(), _createBlock(_component_print_og_data, {
                key: 0,
                og: board.ogData,
                onClick: ($event: any) => (_ctx.openLink(board.ogData.url))
              }, null, 8, ["og", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    (_ctx.hasMore)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "ion-activatable ripple-parent load_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'의견목록', 'clickContent':'더보기'}); _ctx.loadBoardMore()})
        }, [
          _hoisted_22,
          _hoisted_23,
          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}